import React from 'react'

function setListeners(tableId: string, div: HTMLDivElement) {
  let pageX: number | undefined, curCol: any, curColWidth: number | undefined, tableWidth: number

  div.addEventListener('mousedown', function (e) {
    const table = document.getElementById(tableId)

    if (table && e.target) {
      tableWidth = table?.offsetWidth
      curCol = (e.target as any)?.parentElement
      pageX = e.pageX

      const padding = paddingDiff(curCol)

      curColWidth = curCol?.offsetWidth - padding
    }
  })

  div.addEventListener('mouseover', function (e) {
    if (e?.target) {
      ;(e.target as any).style.borderRight = '2px solid #0000ff'
    }
  })

  div.addEventListener('mouseout', function (e) {
    if (e?.target) {
      ;(e.target as any).style.borderRight = ''
    }
  })

  document.addEventListener('mousemove', function (e) {
    if (curCol) {
      const diffX = e.pageX - Number(pageX)
      const table = document.getElementById(tableId)

      curCol.style.width = Number(curColWidth) + diffX + 'px'

      if (table) {
        table.style.width = tableWidth + diffX + 'px'
      }
    }
  })

  document.addEventListener('mouseup', function (e) {
    curCol = undefined
    pageX = undefined
    curColWidth = undefined
  })
}

function createDiv(height: number) {
  const div = document.createElement('div')

  div.style.top = '0'
  div.style.right = '0'
  div.style.width = '5px'
  div.style.position = 'absolute'
  div.style.cursor = 'col-resize'
  div.style.userSelect = 'none'
  div.style.height = height + 'px'
  return div
}

function paddingDiff(col: any) {
  if (getStyleVal(col, 'box-sizing') == 'border-box') {
    return 0
  }

  const padLeft = getStyleVal(col, 'padding-left')
  const padRight = getStyleVal(col, 'padding-right')
  return parseInt(padLeft) + parseInt(padRight)
}

function getStyleVal(element: any, css: any) {
  return window.getComputedStyle(element, null).getPropertyValue(css)
}

export function resizableGrid(tableId: string, table: HTMLTableElement) {
  const row = table?.getElementsByTagName('tr')[0],
    cols = row ? row?.children : undefined
  if (!cols) return

  table.style.overflow = 'hidden'

  const tableHeight = table?.offsetHeight

  for (const element of cols as any) {
    const div = createDiv(tableHeight)

    element.appendChild(div)
    element.style.position = 'relative'
    setListeners(tableId, div)
  }
}

export function renderTableNode(children: React.ReactNode | string) {
  return children
}
